<template>
	<div
		class="requisite-page_requisite-target-type"
		:class="[
      {
        'requisite-target-type__active': isActive && !isDisabled,
        'requisite-target-type__disabled': isDisabled,
      }
    ]"
	>
		<p class="requisite-target-type_title">{{ title }}</p>
		<p class="requisite-target-type_text">{{ description }}</p>
	</div>
</template>

<script setup lang="ts">
interface Props {
	title: string;
	description: string;
	isActive: boolean;
	isDisabled?: boolean;
}

defineProps<Props>();
</script>

<style scoped lang="scss">
.requisite-page_requisite-target-type {
	flex: 1;
	display: flex;
	padding: 12px;
	background-color: var(--white1);
	border-radius: 8px;
	flex-direction: column;
	gap: 4px;
	align-items: center;
	text-align: center;
	border: 1px solid var(--grey8);
	cursor: pointer;
	transition: all 0.2s ease;

	&.requisite-target-type__active {
		border-color: var(--blue1);
		//border-width: 2px;
	}

	&.requisite-target-type__disabled {
		cursor: none;
		opacity: 0.55 !important;
		pointer-events: none !important;
	}

	.requisite-target-type {
		&_title {
			@include text(16px, 500, var(--brown1), 19.2px);
		}

		&_text {
			@include text(12px, 400, var(--grey2), 14.4px);
		}
	}
}
</style>
